module.exports = __webpack_public_path__ + "media/119.9a6a21ad.wav";